var OrgUnitHierarchyCtrl = function ($scope) {
    $scope.links = [];
    $scope.remove = function(index){
        $scope.links.splice(index, 1);
    };
    $scope.add = function(){
        $scope.links.push({});
    };
    $scope.selectableHierarchies = function(index){
        var _hierarchies = $scope.hierarchies;
        var _links = $scope.links;
        var _selectableHierarchies = [];
        yloop: for(var y=0; y<_hierarchies.length; y++){
            var hrchy = _hierarchies[y];
            xloop: for(var x=0; x<_links.length; x++){
                var linkHrchy = _links[x].hierarchy;
                if(x!=index && linkHrchy && linkHrchy.id == hrchy.id) continue yloop;
            }
            _selectableHierarchies.push(hrchy);
        }
        return _selectableHierarchies;
    };
};
OrgUnitHierarchyCtrl.$inject = ['$scope'];
angular.module('app').controller('OrgUnitHierarchyCtrl',OrgUnitHierarchyCtrl);